import { useTranslation } from 'react-i18next'

import styles from './StepVisualFilters.module.scss'

/**
 * Шаг 02 «Проверяете фильтры» — миниатюра панели плана
 * (`AppWizard/launch/FiltersRail.tsx` + `Home/plan/SearchPlanPanel.tsx`), 320×180.
 *
 * СМЫСЛ ШАГА ОДИН: каждое значение фильтра посчитано по живому индексу, а мёртвое отброшено ДО
 * того, как потрачен кредит. Его несут число рядом с каждым чипом и один зачёркнутый чип. Всё,
 * что этого не несло, из карточки вычищено — служебные подписи, свёрнутые группы без значений и
 * повтор того, что уже написано текстом шага рядом.
 *
 * ПОЛОСА — НЕ ПРОГРЕСС. Она взята из настоящей панели плана (`SearchPlanPanel`, блок `recency`),
 * где делит охват по свежести активности: `home.plan.bands.*` — active this month / this quarter /
 * this year / older. Полоса прогресса со второго экрана сюда не годится: на шаге фильтров ничего
 * не выполняется, и «80%» означали бы ход прогона, которого нет.
 *
 * Число 13 у Engineering измерено ИМЕННО в функциях: `server/src/engine/structural.ts` меряет его
 * в одном прогоне с «Consulting 43 477». Переставить его к должностям значило бы подписать
 * измерение не тем полем.
 */
/* В `label` лежат КЛЮЧИ, а не текст: они уходят в t() через переменную, и проверка i18n их не
   видит. Перечислены явно: app.steps.roles.titles, app.steps.roles.function,
   app.steps.industries.railTitle, landing.how.cards.where. Три первых — подписи из самого продукта.
   Значения чипов ключами НЕ становятся: должности и таксономия LinkedIn показываются дословно. */
const GROUPS = [
  {
    label: 'app.steps.roles.titles',
    chips: [
      { value: 'Founder', n: '8,240' },
      { value: 'CTO', n: '1,860' },
    ],
  },
  {
    label: 'app.steps.roles.function',
    chips: [
      { value: 'Consulting', n: '43,477' },
      /* Посчитано и выброшено до траты: в ANDed-фильтре охват 13 арифметически равен нулю.
         Продукт сообщает об этом, а не вычищает молча. */
      { value: 'Engineering', n: '13', dead: true },
    ],
  },
  {
    label: 'app.steps.industries.railTitle',
    chips: [
      { value: 'IT', n: '35,034' },
      { value: 'Startup', n: '23,543' },
    ],
  },
  {
    label: 'landing.how.cards.where',
    chips: [
      { value: 'United States', n: '52,735' },
      { value: 'UK', n: '8,328' },
    ],
  },
]

/** Доли полосы — те же четыре окна свежести, что считает `recencyBands`. */
const BANDS = [
  { key: 'd30', share: 34 },
  { key: 'd90', share: 27 },
  { key: 'd365', share: 24 },
  { key: 'older', share: 15 },
] as const

export const StepVisualFilters = () => {
  const { t } = useTranslation()

  return (
    <div className={styles.root}>
      <div className={styles.total}>
        <b className={styles.count}>12,480</b>
        <span className={styles.caption}>{t('landing.how.cards.matchCount')}</span>
      </div>

      <div className={styles.recency}>
        <div className={styles.bar}>
          {BANDS.map((band) => (
            <i key={band.key} className={styles[band.key]} style={{ flex: band.share }} />
          ))}
        </div>
        <div className={styles.legend}>
          <span>
            <i className={styles.d30} />
            4,240 {t('landing.how.cards.activeThisMonth')}
          </span>
        </div>
      </div>

      <div className={styles.groups}>
        {GROUPS.map((group) => (
          <div key={group.label} className={styles.group}>
            <span className={styles.label}>{t(group.label)}</span>
            <span className={styles.chips}>
              {group.chips.map((chip) => (
                <span key={chip.value} className={chip.dead ? styles.chipDead : styles.chip}>
                  <span className={styles.value}>{chip.value}</span>
                  <i className={styles.n}>{chip.n}</i>
                  {chip.dead ? <u className={styles.mark}>{t('landing.how.cards.dropped')}</u> : null}
                </span>
              ))}
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}
